import React, { Component } from "react"
import { Helmet } from "react-helmet"
import { MetaData, structuredPageData } from "../../shared/structureData"
import { Redirect } from "react-router"
import * as imageAsset from "../../shared/images"

import "./etrInsights.scss"

class EtrInsightsLanding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      backgroundImage: "image-1",
    }
  }

  pageSEO = () => {
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/etr-insights"
    seo.title = `ETR Insights | ETR`
    seo.image = imageAsset.defaultLogo
    seo.description =
      "ETR Insights uncovers what is driving enterprise technology trends, by converging community & content, overlapping the intelligence of Investors, Vendors & CIOs."
    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  navigate = (url) => {
    this.props.history.push(url)
  }

  onLinkClicked = (e, description, from, url) => {
    e.preventDefault()
    this.props.trackEvent(description, {
      from: from,
    })
    this.props.history.push(url)
  }

  componentDidMount() {
    const images = ["image-1", "image-2", "image-3"]
    const backgroundImage = images[Math.floor(Math.random() * 3)]

    this.setState({
      backgroundImage: backgroundImage,
    })
  }

  render() {
    if (!this.props.viewer || !this.props.viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{ pathname: "/login", state: { from: "/etr-insights" } }}
        />
      )
    }
    return (
      <section id="venn-landing" className={`${this.state.backgroundImage}`}>
        {this.pageSEO()}
        <div className="container">
          <img
            src={imageAsset.etrWhiteInsightsLogo}
            className="logo-2xl"
            alt="ETR Insights"
          />
          <div className="venn-options">
            <div className="venn-option-container">
              <div
                className="option venn-info animate-pop-in"
                onClick={(e) =>
                  this.onLinkClicked(
                    e,
                    "Learn About button",
                    "About ETR Insights",
                    "/etr-insights/about"
                  )
                }
              >
                <h2 className="header">About</h2>
                <img
                  src={imageAsset.etrInsightsCircleMicIcon}
                  className="logo-md"
                  alt="ETR Insinghts"
                />
                <p className="sub-header">The ETR Insights Platform</p>
                <p>
                  Event-based research that leverages the knowledge of CIOs/IT
                  Decision Makers, Technology Vendor Executives and Investors
                </p>
              </div>
              <div
                className={"option venn-search animate-pop-in"}
                onClick={(e) =>
                  this.onLinkClicked(
                    e,
                    "ETR Insights Search button",
                    "About ETR Insights",
                    "/etr-insights/search"
                  )
                }
              >
                <h2 className="header">Transcription Search</h2>
                <img
                  src={imageAsset.etrInsightsCircleSearchIcon}
                  className="logo-md"
                  alt="ETR Insinghts"
                />
                <p className="sub-header">Subscriber Feature</p>
                <p>
                  Mine ETR Insights transcript database with full language
                  search functionality of expert interviews and events
                </p>
              </div>
              <div
                className="option venn-calendar animate-pop-in"
                onClick={(e) =>
                  this.onLinkClicked(
                    e,
                    "VENN Calendar button",
                    "About ETR Insights",
                    "/etr-insights/calendar"
                  )
                }
              >
                <h2 className="header">Calendar</h2>
                <img
                  src={imageAsset.etrInsightsCircleCalendarIcon}
                  className="logo-md"
                  alt="ETR Insinghts"
                />
                <p className="sub-header">Explore Past and Present</p>
                <p>
                  Browse all ETR Insights events, sign up to participate live or
                  virtually, and access the full suite of content
                </p>
              </div>
            </div>
          </div>
          <span
            className="btn btn-light btn-outline animate-pop-in view-all-btn"
            onClick={(e) =>
              this.onLinkClicked(
                e,
                "Search all ETR Insights Events button",
                "About ETR Insights",
                "/marketplace?reportType=VENN"
              )
            }
          >
            View all ETR Insights Reports{" "}
            <span className="fa fa-arrow-right icon animate-btn-arrow"></span>
          </span>
        </div>
      </section>
    )
  }
}

export default EtrInsightsLanding
